<script setup lang="ts">
import { baseButtonGroupVariants } from './';

interface Props {
  variant?: NonNullable<Parameters<typeof baseButtonGroupVariants>[0]>['variant'];
}

defineProps<Props>();

</script>

<template>
  <div :class="baseButtonGroupVariants({ variant })">
    <slot />
  </div>
</template>

<style scoped>
.c-base-button-group {
  display: flex;
  flex-direction: column;
  gap: var(--button-group-gap, 0.75rem);
  align-items: center;

  @screen tablet-wide {
    gap: var(--button-group-gap, 2rem);
    flex-direction: row;
  }

  &--center {
    justify-content: center;
  }
}
</style>
